import React from "react";
import chart1 from '../assets/results/results_1st.jpg'
import chart2 from '../assets/results/results_2nd.jpg'
import chart3 from '../assets/results/results_3rd.jpg'
import chart4 from '../assets/results/results_4th.jpg'



const Result = ({section}) =>{

    const charts = {
        '1st':chart1,
        '2nd':chart2,
        '3rd':chart3,
        '4th': chart4
    }

    return(
        <div className="result_wrapper">
            
                <div className="quartile_heading">
                <img className="result_icon" src={section.icon} />
                <div className="result_heading">

                    <h1>{section.title}</h1>
                    <p>You rank in the <span>{section.quartile}</span> quartile:</p>
                </div>
                </div>
                <img className="quartile_chart" src={charts[section.quartile]} />
                <div className="value_statement">
                    <p>{section.statements[section.quartile]}</p>
                </div>
            

        </div>
    )
}

export default Result